// @flow
import { toastr } from 'react-redux-toastr';
import { initialFilters } from './chargeReconciliationReducer';
import { makeApiCall } from '../../../../services/apiService/apiService';

const initialTableData = {
  isLoading: false,
  isSuccess: false,
  chargeReconciliationData: [],
  totalElements: 0
};

export const chargeReconciliationActions = {
  GET_CHARGE_RECONCILIATION_DATA: 'GET_TASKBOARD_DATA',
  UPDATE_PAGE_NUMBER: 'UPDATE_PAGE_NUMBER',
  UPDATE_FILTER: 'UPDATE_FILTER',
  UPDATE_SEARCH: 'UPDATE_SEARCH'
};

export const getChargeReconciliationDataAction = payload => ({
  type: chargeReconciliationActions.GET_CHARGE_RECONCILIATION_DATA,
  payload
});

export const updatePageNumber = payload => {
  return {
    type: chargeReconciliationActions.UPDATE_PAGE_NUMBER,
    payload
  };
};

export const updateFilter = (key, payload) => ({
  type: chargeReconciliationActions.UPDATE_FILTER,
  key,
  payload
});

export const updateSearch = payload => ({
  type: chargeReconciliationActions.UPDATE_SEARCH,
  payload
});

export const getChargeReconciliationData = () => (dispatch, getState) => {
  const { chargeReconciliationState } = getState();
  dispatch(
    getChargeReconciliationDataAction({
      isLoading: true,
      isSuccess: false
    })
  );
  let startDate =
    chargeReconciliationState.filters.dateFilters &&
    chargeReconciliationState.filters.dateFilters.fromDate;
  if (startDate) {
    startDate = parseInt(startDate);
    startDate = new Date(new Date(startDate).setHours(0, 0, 0, 0)).getTime();
  }
  let endDate =
    chargeReconciliationState.filters.dateFilters &&
    chargeReconciliationState.filters.dateFilters.toDate;
  if (endDate) {
    endDate = parseInt(endDate);
  }

  const replaceParamsArr = [
    {
      key: 'clientCodes',
      val:
        chargeReconciliationState.filters.client &&
        chargeReconciliationState.filters.client.clientCode
    },
    {
      key: 'escalationStatus',
      val:
        chargeReconciliationState.filters.status &&
        chargeReconciliationState.filters.status.value
    },
    { key: 'search', val: chargeReconciliationState.filters.searchString },
    { key: 'pageNumber', val: chargeReconciliationState.pageNumber + 1 },
    { key: 'pageSize', val: chargeReconciliationState.pageSize },
    { key: 'fromDate', val: startDate },
    { key: 'toDate', val: endDate },
    {
      key: 'escalationCategory',
      val:
        chargeReconciliationState.filters.category &&
        chargeReconciliationState.filters.category.value
    }
  ].filter(item => !!item.val);

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getChargeReconciliation',
    method: 'GET',
    replaceParamsArr,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getChargeReconciliationDataAction({
            isLoading: false,
            isSuccess: true,
            chargeReconciliationData: res.payload.chargeRecViewDtos,
            totalElements: res.payload.totalElements,
            showPagination: true
          })
        );
        dispatch(
          getChargeReconciliationDataAction({
            isLoading: false,
            isSuccess: false
          })
        );
      } else {
        dispatch(
          getChargeReconciliationDataAction({
            isLoading: false,
            isSuccess: false
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getChargeReconciliationDataAction({
          isLoading: false,
          isSuccess: false
        })
      );
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not get tasks'
      );
    },
    catchCb: res => {
      dispatch(
        getChargeReconciliationDataAction({
          isLoading: false,
          isSuccess: false
        })
      );
      toastr.error('Something went wrong!', 'Could not get tasks');
    }
  };

  return makeApiCall(requestObj);
};

export const getSearchChargeReconciliationData = () => (dispatch, getState) => {
  const { chargeReconciliationState } = getState();

  dispatch(
    getChargeReconciliationDataAction({
      isLoading: true,
      isSuccess: false
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getSearchChargeReconciliation',
    method: 'GET',
    replaceParamsArr: [{ key: 'cnote', val: chargeReconciliationState.search }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(updateFilter(initialFilters));
        dispatch(
          getChargeReconciliationDataAction({
            isLoading: false,
            isSuccess: true,
            chargeReconciliationData: [res.payload],
            totalElements: res.payload.totalElements,
            pageNumber: 0,
            pageSize: 10,
            showPagination: false
          })
        );
      } else {
        dispatch(
          getChargeReconciliationDataAction({
            isLoading: false,
            isSuccess: false
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getChargeReconciliationDataAction({
          isLoading: false,
          isSuccess: false
        })
      );
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not get tasks'
      );
    },
    catchCb: res => {
      dispatch(
        getChargeReconciliationDataAction({
          isLoading: false,
          isSuccess: false
        })
      );
      toastr.error('Something went wrong!', 'Could not get tasks');
    }
  };

  return makeApiCall(requestObj);
};

export const updateChargeReconciliationStatus = (payload, dispatcher, cb) => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    method: 'PUT',
    apiEndPoint: 'statusChargereReconciliation',
    pathVariables: [{ key: '{ctaAction}', val: payload.ctaAction }],
    replaceParamsArr: [
      {
        key: 'chargeReconciliationDeltaId',
        val: payload.id
      }
    ],
    data: {},
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatcher();
      } else {
        toastr.error('Error', res.errorMessage);
      }
      cb();
    },
    failureCb: err => {
      toastr.error('Error', err.errorMessage);
      cb();
    },
    catchCb: err => {
      toastr.error('Something went wrong!');
      cb();
    }
  };

  return makeApiCall(requestObj);
};
